<template>
    <Modal v-if="isOpen">
        <ModalCard
            @cancel="this.refuseCancel"
            :activeValidate="refuseSelected !== null"
            :headerTitle="$t('devis.modal.refuse.title', { id })"
            @confirm="this.refuseConfirm"
        >
            <div>
                {{ $t('devis.modal.refuse.precise') }}
            </div>
            <div class="radio-container">
                <span @click="() => this.selectRefuse('SANS_SUITE')" class="radioField">
                    <RadioBox :selected="refuseSelected === 'SANS_SUITE'" />
                    {{ $t('devis.modal.refuse.projectAbandonned') }}
                </span>
                <span @click="() => this.selectRefuse('PERDU')" class="radioField">
                    <RadioBox :selected="refuseSelected === 'PERDU'" />
                    {{ $t('devis.modal.refuse.anotherSuccessfulOffer') }}
                </span>
                <span @click="() => this.selectRefuse('NEGOTIATION')" class="radioField">
                    <RadioBox :selected="refuseSelected === 'NEGOTIATION'" />
                    {{ $t('devis.modal.refuse.askNewVersion') }}
                </span>
            </div>
            <div class="comment">
                <div>
                    {{ $t('devis.modal.refuse.titleComment') }}
                </div>
                <div class="input-container">
                    <textarea
                        @blur="toggleDescriptionFocus(false)"
                        @focus="toggleDescriptionFocus(true)"
                        name="descriptif"
                        v-model="commentValueModel"
                        id="descriptif"
                        cols="30"
                        rows="7"
                        maxlength="4000"
                    />
                    <span class="label" :class="commentValue || this.commentFocus ? 'active-label' : ''">
                        {{ $t('devis.modal.refuse.labelComment') }}
                    </span>
                </div>
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import RadioBox from '@/components/ui-components/RadioBox.vue';

export default defineComponent({
    name: 'ModalRefuse',
    components: { Modal, ModalCard, RadioBox },
    data() {
        return {
            commentFocus: false,
        };
    },
    props: {
        id: { type: String, required: true },
        isOpen: { type: Boolean, required: true },
        commentValue: { type: String, required: true },
        refuseSelected: { type: String, required: true },
    },
    methods: {
        refuseCancel() {
            this.$emit('refuseCancel');
        },
        refuseConfirm() {
            this.$emit('refuseConfirm');
        },
        selectRefuse(value: string) {
            this.$emit('selectRefuse', value);
        },
        toggleDescriptionFocus(value: boolean) {
            this.commentFocus = value;
        },
    },
    computed: {
        commentValueModel: {
            get(): string {
                return this.$props.commentValue;
            },
            set(value: string) {
                this.$emit('setCommentValue', value);
            },
        },
    },
});
</script>

<style scoped>
.radio-container {
    display: flex;
    margin-top: 8px;
}
.radioField:not(:first-child) {
    margin-left: 16px;
}
.radioField {
    display: flex;
    align-items: center;
    cursor: pointer;
}
.radio-icon {
    margin-right: 8px;
}
.comment {
    margin-top: 16px;
}
textarea {
    border: none;
    outline: none;
    flex: 1;
    color: var(--black);
    resize: none;
    height: 100%;
}
.input-container {
    margin-top: 8px;
    height: 16px;
    position: relative;
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
    width: 50%;
    height: 100px;
}
.label {
    left: 12px;
    position: absolute;
    pointer-events: none;
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    top: 8px;
    font-size: var(--font-size-low-medium);
}
.active-label {
    left: 12px;
    top: -8px;
    font-size: var(--font-size-very-small);
}
</style>
